<template>
  <a-modal
    width="70%"
    :title="title"
    :visible="innerVisible"
    @cancel="handleCancel"
    cancelText="关闭"
    :okButtonProps="{ style: { display: 'none' } }"
  >
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="12">
          <a-col :md="6" :sm="12">
            <a-form-item label="物探点号">
              <a-input v-model="query.geophysicalPointNumber" placeholder="请输入物探点号" allow-clear />
            </a-form-item>
          </a-col>
          <a-col :md="4" :sm="12">
            <span class="table-page-search-submitButtons">
              <a-button type="primary" @click="loadData">查询</a-button>
              <a-button style="margin-left: 8px" @click="resetList">重置</a-button>
              <a-button type="danger" style="margin-left: 8px" @click="handleEmpty">一键清空</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <a-alert type="info" showIcon style="margin-bottom: 16px; margin-top: 16px">
      <template slot="message">
        <span>已选择</span>
        <a style="font-weight: 600; padding: 0 4px;">{{ selectedRowKeys.length }}</a>
        <span>项</span>
        <template v-if="selectedRowKeys.length > 0">
          <a-divider type="vertical" />
          <a @click="handleClearSelection">清空选择</a>
          <a-divider type="vertical" />
          <a @click="handleRevertBatch">批量还原</a>
          <a-divider type="vertical" />
          <a @click="handleDeleteBatch">批量删除</a>
        </template>
      </template>
    </a-alert>
    <a-table
      ref="table"
      rowKey="id"
      size="middle"
      bordered
      :columns="columns"
      :loading="loading"
      :dataSource="dataSource"
      :pagination="pagination"
      :rowSelection="{ selectedRowKeys, onChange: handleTableSelectChange }"
      @change="pageChange"
    >
      <span slot="action" slot-scope="text, record">
        <a @click="handleRevert([record.id])"> <a-icon type="redo" />还原 </a>
        <a-divider type="vertical" />
        <a @click="handleDelete([record.id])"> <a-icon type="delete" />清理 </a>
      </span>
    </a-table>
  </a-modal>
</template>

<script>
export default {
  name: 'LineCheckRecycleBinModal',
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      title: '管线数据检查回收站',
      loading: false,
      innerVisible: false,
      selectedRowKeys: [],
      dataSource: [],
      query: {
        geophysicalPointNumber: '',
      },
      columns: [
        { title: '序号', align: 'center', key: 'rowIndex', width: 80, customRender: (t, r, i) => i + 1 },
        {
          title: '开始分类编码',
          dataIndex: 'startClassNo',
        },
        {
          title: '结束分类编码',
          dataIndex: 'eneClassNo',
        },
        {
          title: '物探点号',
          dataIndex: 'startGeophysicalPointNumber',
        },
        {
          title: '连接点号',
          dataIndex: 'endGeophysicalPointNumber',
        },
        {
          title: '检查类型',
          dataIndex: 'checkType',
        },
        {
          title: '修复建议',
          dataIndex: 'fixMessage',
        },
        {
          title: '操作',
          align: 'center',
          dataIndex: 'action',
          width: 150,
          scopedSlots: { customRender: 'action' },
        },
      ],
      url: {
        recycleBin: 'pipe-network/gis/pipe-line/data-check/page-recovery-line',
        resume: 'pipe-network/gis/pipe-line/data-check/resume-line',
        empty: 'pipe-network/gis/pipe-line/data-check/empty-recycle-line',
        batchDelete: 'pipe-network/gis/pipe-line/data-check/batch-delete-recovery-line',
      },
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0,
        showTotal: (total) => `共 ${total} 条记录`,
        showSizeChanger: true,
        pageSizeOptions: ['10', '20', '50', '100'],
      },
    }
  },
  watch: {
    visible: {
      immediate: true,
      handler(val) {
        if (val) {
          this.loadData()
        }
        this.innerVisible = val
      },
    },
    innerVisible(val) {
      this.$emit('update:visible', val)
    },
  },
  methods: {
    pageChange(pagination) {
      this.pagination.current = pagination.current
      this.pagination.pageSize = pagination.pageSize
      this.loadData()
    },
    resetList() {
      this.query = {
        geophysicalPointNumber: '',
      }
      this.pagination.current = 1
      this.loadData()
    },
    loadData() {
      this.loading = true
      const params = {
        page: this.pagination.current,
        limit: this.pagination.pageSize,
        ...this.query,
      }
      this.$http
        .get(this.url.recycleBin, {
          params,
        })
        .then(({ data }) => {
          this.pagination.total = data.total ? parseInt(data.total) : 0
          this.dataSource = data.list || []
        })
        .catch((err) => {
          this.$message.error('加载回收站数据失败')
          console.error(err)
        })
        .finally(() => {
          this.loading = false
        })
    },
    handleOk() {
      this.loadData()
      this.$emit('ok')
    },
    handleCancel() {
      this.innerVisible = false
    },
    // 还原数据
    handleRevert(ids) {
      this.$confirm({
        title: '恢复数据',
        content: `您确定要恢复这 ${ids.length} 条数据吗？`,
        centered: true,
        onOk: () => {
          this.$http.put(this.url.resume, ids).then((res) => {
            if (res.code === 0) {
              this.handleOk()
              this.handleClearSelection()
              this.$message.success(`还原 ${ids.length} 个数据成功！`)
            } else {
              this.$message.error(res.message || '还原失败')
            }
          })
        },
      })
    },
    // 彻底删除数据
    handleDelete(ids) {
      this.$confirm({
        title: '彻底删除数据',
        content: (
          <div>
            <p>您确定要彻底删除这 {ids.length} 个数据吗？</p>
            <p style="color:red;">注意：彻底删除后将无法恢复，请谨慎操作！</p>
          </div>
        ),
        centered: true,
        onOk: () => {
          this.$http.delete(this.url.batchDelete, { data: ids }).then((res) => {
            if (res.code === 0) {
              this.loadData()
              this.handleClearSelection()
              this.$message.success(`彻底删除 ${ids.length} 条数据成功！`)
            } else {
              this.$message.error(res.message || '彻底删除失败')
            }
          })
        },
      })
    },
    // 一键清空回收站
    handleEmpty() {
      this.$confirm({
        title: '清空回收站',
        content: '您确定要清空回收站吗？此操作不可恢复！',
        centered: true,
        onOk: () => {
          this.$http.delete(this.url.empty).then((res) => {
            if (res.code === 0) {
              this.loadData()
              this.handleClearSelection()
              this.$message.success('回收站已清空')
              this.$emit('ok')
            } else {
              this.$message.error(res.message || '清空失败')
            }
          })
        },
      })
    },
    handleRevertBatch() {
      this.handleRevert(this.selectedRowKeys)
    },
    handleDeleteBatch() {
      this.handleDelete(this.selectedRowKeys)
    },
    handleClearSelection() {
      this.handleTableSelectChange([], [])
    },
    handleTableSelectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys
    },
  },
}
</script>

<style lang="less" scoped></style>

